import { Flex, Text, useModal, Button, CalculateIcon, FlexGap, Balance, Pool } from '@pancakeswap/uikit'
import { LightGreyCard } from 'components/Card'
import { useTranslation } from '@pancakeswap/localization'
import { useVaultApy } from 'hooks/useVaultApy'
import { memo } from 'react'
import { DeserializedLockedCakeVault, Flexible2Locked, IsLocked } from 'state/types'
import styled from 'styled-components'
import { Token } from '@pancakeswap/sdk'
import { useVaultPoolByKey } from 'state/pools/hooks'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { VaultRoiCalculatorModal } from '../Vault/VaultRoiCalculatorModal'
import RecentCakeProfitCountdownRow from './RecentCakeProfitRow'

const AprLabelContainer = styled(Flex)`
  &:hover {
    opacity: 0.5;
  }
`

export const StakingApy = memo(({ pool }: { pool: Pool.DeserializedPool<Token> }) => {
  const { t } = useTranslation()
  const { chainId } = useActiveWeb3React()

  const { flexibleApy, lockedApy } = useVaultApy({chainId, vaultKey: Flexible2Locked(pool.vaultKey)})

  const vaultData = useVaultPoolByKey(pool.vaultKey)

  const isLocked = IsLocked(pool.vaultKey) && (vaultData as DeserializedLockedCakeVault).totalLockedAmount?.gt(0)

  const [onPresentFlexibleApyModal] = useModal(<VaultRoiCalculatorModal pool={pool} />)

  const [onPresentLockedApyModal] = useModal(<VaultRoiCalculatorModal pool={pool} initialView={1} />)

  return (
    <LightGreyCard>
      <Flex alignItems="center" justifyContent="space-between">
        <Text color="textSubtle" textTransform="uppercase" bold fontSize="12px">
          {t('Flexible')} APY:
        </Text>
        <AprLabelContainer alignItems="center" justifyContent="flex-start">
          <Balance fontSize="16px" value={parseFloat(flexibleApy ?? '0')} decimals={2} unit="%" bold />
          <Button
            onClick={(e) => {
              e.stopPropagation()
              onPresentFlexibleApyModal()
            }}
            variant="text"
            width="20px"
            height="20px"
            padding="0px"
            marginLeft="4px"
          >
            <CalculateIcon color="textSubtle" width="20px" />
          </Button>
        </AprLabelContainer>
      </Flex>
      {isLocked && (
        <Flex alignItems="center" justifyContent="space-between">
          <Text color="textSubtle" textTransform="uppercase" bold fontSize="12px">
            {t('Locked')} APR:
          </Text>
          <FlexGap gap="4px" flexWrap="wrap" justifyContent="flex-end" alignItems="baseline">
            <Text style={{ whiteSpace: 'nowrap' }} fontSize="12px" color="textSubtle">
              {t('Up to')}
            </Text>
            <AprLabelContainer alignItems="center">
              <Balance fontSize="16px" value={parseFloat(lockedApy ?? '0')} decimals={2} unit="%" bold />
              <Button
                onClick={(e) => {
                  e.stopPropagation()
                  onPresentLockedApyModal()
                }}
                variant="text"
                width="20px"
                height="20px"
                padding="0px"
                marginLeft="4px"
              >
                <CalculateIcon color="textSubtle" width="20px" />
              </Button>
            </AprLabelContainer>
          </FlexGap>
        </Flex>
      )}
      <RecentCakeProfitCountdownRow pool={pool} />
    </LightGreyCard>
  )
})
